var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { LayoutState } from '../../state/layout.state';
import { LayoutThemeEnum } from '../../models/layout-theme.enum';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { AuthService } from 'src/app/auth/auth.service';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { DialogService } from 'src/app/dialogs/dialog.service';
var MasterComponent = /** @class */ (function () {
    function MasterComponent(renderer, authService, storageService, route, dialogService) {
        this.renderer = renderer;
        this.authService = authService;
        this.storageService = storageService;
        this.route = route;
        this.dialogService = dialogService;
        this.showHeader = false;
        this.ngUnsubscribe = new Subject();
        this.showHeader = this.route.snapshot.data.showHeader;
    }
    MasterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.theme$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (theme) {
            _this.renderer.removeClass(document.body, LayoutThemeEnum.Dark);
            _this.renderer.removeClass(document.body, LayoutThemeEnum.Light);
            _this.renderer.addClass(document.body, theme);
        });
        this.profile$
            .pipe(filter(function (profile) { return profile != null; }), take(1), takeUntil(this.ngUnsubscribe))
            .subscribe(function (profile) {
            _this.checkProfileAccess(profile);
        });
    };
    MasterComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    MasterComponent.prototype.checkProfileAccess = function (profile) {
        var _this = this;
        var profileRestrictions = this.authService.getProfileRestrictions(profile);
        var restrictionSettings = this.storageService.getLocalJSON(StorageItemEnum.GroupRestriction);
        var showDialog = _.get(restrictionSettings, 'dontShowDialog') !== true;
        if (showDialog && (profileRestrictions.email || profileRestrictions.ip)) {
            setTimeout(function () {
                _this.dialogService.openGroupRestrictionDialog({
                    data: __assign({}, profileRestrictions)
                });
            });
        }
    };
    __decorate([
        Select(LayoutState.getTheme),
        __metadata("design:type", Observable)
    ], MasterComponent.prototype, "theme$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], MasterComponent.prototype, "profile$", void 0);
    return MasterComponent;
}());
export { MasterComponent };
